import { inject } from '@angular/core';
import { Router } from '@angular/router';
import { MegaTradeNavigationService } from '../services/mega-trade-navigation.service';

import type { CanActivateChildFn } from '@angular/router';

export const MegaUploadPoolTradeRouteGuard: CanActivateChildFn = (route, state) => {
  const megaTradeNavigationService = inject(MegaTradeNavigationService);
  const router = inject(Router);

  if (state.url === '/mega-upload/upload-pool-info') {
    return true;
  }

  if (
    megaTradeNavigationService.canNavigate == null ||
    megaTradeNavigationService.canNavigate === undefined
  ) {
    router.navigate(['/mega-upload/upload-pool-info']);
    return true;
  }

  return megaTradeNavigationService.canNavigate ? true : false;
};
